import { render } from "./BProgress.vue?vue&type=template&id=4bbc82e6"
import script from "./BProgress.vue?vue&type=script&lang=js"
export * from "./BProgress.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__